import React from 'react'
import PropTypes from 'prop-types'
import {
  SelectContainer,
  StyledPrefix,
  StyledSelect,
} from './ProductSelect.styled'

const ProductSelect = (props) => {
  const {
    className,
    onChange,
    options,
    value,
    isMulti,
    placeholder,
    prefix = null,
  } = props

  return (
    <SelectContainer className={className}>
      {prefix && <StyledPrefix>{prefix}</StyledPrefix>}
      <StyledSelect
        onChange={onChange}
        options={options}
        isMulti={isMulti}
        value={value.label}
        placeholder={placeholder}
      />
    </SelectContainer>
  )
}

ProductSelect.propTypes = {}

export default ProductSelect
